import { buildUrl } from '~/lib/net';
import { addPaycodeFilter } from './helpers';


export class PaycodeEndpoints {
  static getPaycodeById = (paycodeId) => `/v1/pay/preauthorizations/${paycodeId}`;

  // TODO: This is insecure
  static getOrgPaycodes = (orgId, flt = null) => {
    let qs = {} as any;

    if (flt) {
      if (flt.offset) {
        qs.offset = flt.offset;
      }
      if (flt.limit) {
        qs.limit = flt.limit;
      }
      if (flt.hideExpired) {
        qs.hideexpired = 1;
      }

      qs = addPaycodeFilter(qs, flt.filter);
    }

    return buildUrl(`/v1/pay/preauthorizations`, qs);
  };
}

export class BalanceTransactionEndpoints {
  static getBalanceTransactionById = (transactionId: string) => `/api/balance/transactions/${transactionId}`;
  static getOrganizationBalanceTransactions = (orgId: string, offset, limit) =>
    buildUrl('/api/company/${orgId}/balance/transcations/', { offset, limit });
}
